function normalizeExemptionState(rawState) {
  const availableSubjects = Array.isArray(rawState?.availableSubjects)
    ? rawState.availableSubjects
        .map((subject) => ({
          id: String(subject?.id ?? "").trim(),
          nazwa: String(subject?.nazwa ?? "").trim(),
        }))
        .filter((subject) => subject.id !== "" && subject.nazwa !== "")
    : [];

  const selectedSubjectIds = new Set(
    Array.isArray(rawState?.selectedSubjectIds)
      ? rawState.selectedSubjectIds
          .map((subjectId) => String(subjectId ?? "").trim())
          .filter((subjectId) => subjectId !== "")
      : [],
  );

  return {
    availableSubjects,
    selectedSubjectIds,
    hasAssignedSpn: rawState?.hasAssignedSpn === true,
  };
}

function buildExemptionOptionsWrapperClass(optionCount) {
  return optionCount > 4 ? "form__options split" : "d-flex flex-column gap-2 form__options";
}

export function syncExemptionEditorState(rootElement, rawState) {
  if (!(rootElement instanceof HTMLElement)) {
    return;
  }

  const viewRoot = rootElement.closest("[data-student-view]") || document;
  const exemptionState = normalizeExemptionState(rawState);
  const rowElement = viewRoot.querySelector('[data-field-row="nie_obowiazuje_subject_ids"]');
  const inputWrapper = rowElement?.querySelector(".col-sm-8");
  if (!(rowElement instanceof HTMLElement) || !(inputWrapper instanceof HTMLElement)) {
    return;
  }

  const shouldShowRow = exemptionState.hasAssignedSpn && exemptionState.availableSubjects.length > 0;
  rowElement.classList.toggle("d-none", !shouldShowRow);

  if (!shouldShowRow) {
    inputWrapper.replaceChildren();
    return;
  }

  const optionsWrapper = document.createElement("div");
  optionsWrapper.className = buildExemptionOptionsWrapperClass(exemptionState.availableSubjects.length);

  const isReadonly = rowElement.closest(".form")?.classList.contains("form--readonly") === true;

  exemptionState.availableSubjects.forEach((subject) => {
    const item = document.createElement("div");
    item.className = "form-check";

    const input = document.createElement("input");
    input.className = "form-check-input";
    input.type = "checkbox";
    input.name = "nie_obowiazuje_subject_ids[]";
    input.value = subject.id;
    input.id = `field-nie_obowiazuje_subject_ids-${subject.id}`;
    input.checked = exemptionState.selectedSubjectIds.has(subject.id);
    input.disabled = isReadonly;

    const label = document.createElement("label");
    label.className = "form-check-label";
    label.setAttribute("for", input.id);
    label.textContent = subject.nazwa;

    item.append(input, label);
    optionsWrapper.appendChild(item);
  });

  inputWrapper.replaceChildren(optionsWrapper);
}

